import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbCarouselConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BillingManagementService } from '../../../service/billing-management.service';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { ActionType, ActionTypeBillingDetail, AddBillWrapper, AppointmentType, BilledProduct, BillingDetailsSimple, BillingInitialization, BillingMode, BillingStatus, BillingValidation, BusinessEnabledOption, BusinessWrapper, CommunicationTemplate, DecodedQrCode, DeliveryType, FocusInputType, InteractionType, KeyValueId, KeyValues15, KeyValues30, KeyValues3, KeyValueSet, LastUsedKey, LastUsedSettingsType, LocalService, NumericConfig, PageKey, PaymentType, PricingManagementWrapper, ProductPrice, Status, StatusWithId, SupportingType, TriggeredEvent, UsageLimitType, KeyValueIdGroup, KeyValues5 } from '../../../service/local.service';
import { ProductManagementService } from '../../../service/product-management.service';
import { ProfileManagementService } from '../../../service/profile-management.service';
import { SellerManagementService } from '../../../service/seller-management.service';
import { BillHistoryComponent } from '../../popups/bill-history/bill-history.component';
import { DeletedItemsComponent } from '../../popups/deleted-items/deleted-items.component';
import { EditAdditionalDetailsComponent } from '../../popups/edit-additional-details/edit-additional-details.component';
import { EditAppointmentComponent } from '../../popups/edit-appointment/edit-appointment.component';
import { PayFromWalletComponent } from '../../popups/pay-from-wallet/pay-from-wallet.component';
import { ProductValidationComponent } from '../../popups/product-validation/product-validation.component';
import { ReturnProductsComponent } from '../../popups/return-products/return-products.component';
import { SeatsBillingComponent } from '../../popups/seats-billing/seats-billing.component';
import { SerialNumbersMappingComponent } from '../../popups/serial-numbers-mapping/serial-numbers-mapping.component';
import { GetAdjustmentAmount, GetPriceIncludeTax, GetServiceChargeAmount } from 'src/app/supporting/taxCalculator';
import { EmitResponse } from 'src/service/ws/wsSupporting/wsEntities';
import { EmitType, RegisterName } from 'src/service/ws/wsSupporting/wsTypes';
import { WsUserService } from 'src/service/ws/ws-user.service';
import { OfflineService } from 'src/service/offline.service';

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss']
})
export class BillingComponent implements OnInit {
  InteractionType = InteractionType; BillingStatus = BillingStatus; BillingMode = BillingMode; CommunicationTemplate = CommunicationTemplate;
  lstSectionConfigKeys: string[] = ["billing", "common"]; wrapper; billedItems: BillingDetailsSimple; isPrint: boolean = false; ctryCode: string = '';
  businessId: string = ''; billingId = ''; lastbillingId = ''; tableId: string = ''; searchItems: KeyValues30[]; initialization: BillingInitialization; isSearchbarShow = true; isFooterbarShow = true;
  selectedMeasurement = ''; selectedPrice: ProductPrice = null; selectedPrices: ProductPrice[] = []; billingMode: BillingMode = BillingMode.None; interactionType: InteractionType = InteractionType.None; lastBusinessId = ''; allProducts: KeyValues30[]; isAddOrDeleteProduct: boolean = false;
  isDropDownInFooter = 0; relationShipType = InteractionType.Business; productCategories: KeyValues3[]; selectedCategory: string | null = null; userId = '';
  txtAdjustment: number = null; txtDiscount = null; total = 0; maxBodyHeight = 0; isShowSpinnerCount = 0; isAllowedForItem: StatusWithId; billingDetailsSimple: BillingDetailsSimple;
  customerTypes: KeyValueSet[] = [{ key: '1', value: 'Customer' } as KeyValueSet, { key: '2', value: 'Business Customer' } as KeyValueSet,] as KeyValueSet[];
  selectedCustomerType = '1'; isActiveProductAvailable = false; currencyIcon = ''; printingLanguage = ''; isExcluded: boolean = false; isExcludedEnabled: boolean = false; isOverWritePriceEnabled: boolean = false; isOverWriteDiscountEnabled: boolean = false; isDisablePrintOnDraftMode = false; isAllowToModifyOnAcceptedStatus = false;
  numericConfig: NumericConfig = { isDecimalAllowed: true } as NumericConfig; isRoundoffFocused: boolean = false; isDiscountFocused: boolean = false; isPaidFocused: boolean = false; totalIncludeTax: number = 0; selectedBatchId: string = ''; selectedMeasurementType: string = '';
  selectedProductIdToUpdatePrice: string = ''; currentPriceBeforeUpdate: number | null = null;

  business: BusinessWrapper = null; serviceTaxPercentage: number = 0; businessTaxes: KeyValueIdGroup[] | undefined;
  isBillTaxesPopupOpen = false; taxTitles: KeyValueId[] = []; isNotConsiderTax = true;
  isLocalPrintersAvailable = false; hasValidBatchDetails = false; isInventoryEnabled = false;
  isShowQuickPickImage = false; isDisableReturnInBilling = false; isDisablePrintInViewMode = false;
  isPrintOncePaid = false; isNaviateToNewBillIfPaid = false;
  isGenerateQr = false; SupportingType = SupportingType; measurmentTypes: KeyValueSet[] = [];
  isOpenCustomLabelPrint = false; isOpenPaymentModes = false; selectedId = ''; isOpenOwerwritePrice = false; isOpenOwerwriteDiscount = false;
  quickSearchKey: string = ''; selectedBillingMode: string = ''; isOpenSendToPhone = false; isHiddenProcess = true;
  isCompactQuickPick: boolean = false; isShowSelected = false; valueBeforeFocusOut: any;
  isViewMode: boolean = false; isDedicatedStorageAvailable: boolean = false; returnData: any;
  isShowSendToPhone: boolean = false;

  isStartCamera: boolean = false;

  numericConfigRoundoff: NumericConfig = { isDecimalAllowed: true, isNegativeAllowed: true } as NumericConfig;
  elementIds: any = {
    product_dd: 'billing_product_dd',
    batch_dd: 'billing_batch_dd',
    mearsurement_dd: 'mearsurement_dd',
    qty: 'billing_qty',
    price: 'billing_price',
    brn: 'brn',
    currently_with: 'currently_with',
    dd_print_language: 'dd_print_language',
    print_language: 'print_language',
    dd_payment_mode: 'dd_payment_mode',
    payment_mode: 'payment_mode',
    dd_delivery_method: 'dd_delivery_method',
    delivery_method: 'delivery_method',
    btn_add: 'add_bill_item',
    txt_notes: 'txt_notes',
    txt_notes_summary: 'txt_notes_summary',
    txt_token_num: 'txt_token_num',
    brn_search_billing_customer: 'brn_search_billing_customer',
    brn_search_billing_customer_business: 'brn_search_billing_customer_business',
    btn_accept: 'btn_accept',
    btn_submit: 'btn_submit',
    txt_quick_search: 'txt_quick_search',
    scanner_camera: 'billing_scanner_camera'
  };

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private productManagementService: ProductManagementService, private route: ActivatedRoute, private billingManagementService: BillingManagementService, private router: Router, private modalService: NgbModal, private sellerManagementService: SellerManagementService, public profileManagementService: ProfileManagementService, private configurationManagementService: ConfigurationManagementService, private wsUserService: WsUserService, private offlineService: OfflineService, ngbCarouselConfig: NgbCarouselConfig) {
    ngbCarouselConfig.interval = 5000;
    ngbCarouselConfig.wrap = false;
    ngbCarouselConfig.keyboard = false;
    ngbCarouselConfig.pauseOnHover = false;
  }

  ngOnInit() {
    this.onReset();
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);

    this.billingMode = this.localService.onGetCurrentDeviceSettingsOfBusiness()?.BillingMode as number ?? BillingMode.Receipt;

    this.selectedBillingMode = this.billingMode.toString();
    this.localService.getLastUsedSetting(LastUsedSettingsType.VisitedURL);

    this.onCheckWsBusinesEmitDetection();
    this.onCheckDeviceSettings();

    this.route.params.subscribe(routeParams => {
      this.tableId = routeParams.tableId ?? '';
      this.isViewMode = this.route.snapshot.pathFromRoot.some(r => r.routeConfig?.path?.includes('billing-view'));
      if (this.businessId != routeParams.businessId) {
        this.onReset();
        this.interactionType = parseInt(routeParams.interactionType);
        this.businessId = routeParams.businessId;
        this.onCheckLocalPrinter();
        this.onGetBusiness();
        this.configurationManagementService.ensurePageActions(this.interactionType == InteractionType.Business || this.interactionType == InteractionType.Bill_PnixSoft ? PageKey.BillingBusiness : PageKey.Billing, this.businessId);
        if (this.interactionType != InteractionType.User && (this.businessId == '' || this.businessId == '0')) {
          this.localService.redirectToSeller();
        } else {
          this.localService.saveUrl();
          this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
          this.billingId = routeParams.id;
          this.userId = routeParams.userId;
          this.ctryCode = routeParams.ctryCode;
          // if (this.billingId == '' || this.billingId == '0') {
          //   this.isAllowedForItem = { id: '', status: Status.Success } as StatusWithId;
          //   this.lastbillingId = this.billingId;
          // }

          this.onCheckBusinessEnabledOptions(true);
          if (this.lastbillingId != this.billingId) {
            this.isAllowedForItem = null;
          }
          if (this.isAllowedForItem && this.isAllowedForItem.status == Status.Success) {
            this.onLoad();
          } else {
            this.profileManagementService.isAllowedForItem(this.billingId, this.businessId).subscribe(result => {
              this.isAllowedForItem = result;
              if (this.isAllowedForItem.status == Status.Success) {
                this.lastbillingId = this.billingId;
                this.onLoad();
              }
            });
          }
        }
      } else if (this.billingId != routeParams.id) {
        this.localService.saveUrl();
        if (this.billingId == '0') {
          this.onReset(false);
        }
        this.billingId = routeParams.id;
        this.lastbillingId = this.billingId;
        this.onLoad();
      }
    });
  }

  onCheckDeviceSettings() {
    if (this.interactionType == InteractionType.User) {
      this.billingMode = BillingMode.QuickPick;
      this.isCompactQuickPick = true;
    } else {
      if (this.billingMode == BillingMode.QuickPick) {
        this.isCompactQuickPick = this.localService.onGetCurrentDeviceSettingsOfBusiness().IsCompactViewInBillingMode;
        this.onSetProductCategories();
      } else {
        this.isCompactQuickPick = false;
      }
    }
  }

  onSetProductCategories() {
    if (this.isCompactQuickPick && this.productCategories && this.productCategories.filter(x => x.key == '0').length == 0) {
      this.productCategories = [
        {
          key: '0',
          v1: this.localService.languageContent.billing.all_products
        } as KeyValues3,
        {
          key: '1',
          v1: this.localService.languageContent.billing.selected_products
        } as KeyValues3,
        ...this.productCategories
      ];
    }
  }

  onCheckBusinessEnabledOptions(isTimeDelayeRequired = false) {
    this.isShowQuickPickImage = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.IsShowImageInQuickPick);
    this.isInventoryEnabled = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.HasInventory);
    this.hasValidBatchDetails = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.IsEnableBatchDetails);
    this.isExcludedEnabled = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.IsExcludedPricingEnabled);
    this.isOverWritePriceEnabled = this.interactionType != InteractionType.User && this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.CanOverWritePricing) && this.billedItems && this.billedItems.bill && this.billedItems.bill.v4 == '0';
    this.isOverWriteDiscountEnabled = this.interactionType != InteractionType.User && this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.CanOverWriteDiscount) && this.billedItems && this.billedItems.bill && this.billedItems.bill.v4 == '0';
    this.isAllowToModifyOnAcceptedStatus = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.AllowToModifyOnAcceptedStatus);
    this.isDisablePrintOnDraftMode = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.DisablePrintOnDraft);
    this.isDisableReturnInBilling = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.DisableReturnItemInBilling);
    this.isDisablePrintInViewMode = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.DisablePrintInViewMode);
    this.isPrintOncePaid = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.PrintOncePaid);
    this.isNaviateToNewBillIfPaid = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.NaviateToNewBillIfPaid);
    this.isShowSendToPhone = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.ShowSmsButtonInBillingPage);
    if (this.hasValidBatchDetails) {
      this.billingMode = BillingMode.Receipt;
    }
    setTimeout(() => {
      this.onCheckDeviceSettings();
      this.onSetAfterBilledProductsLoad();
    }, isTimeDelayeRequired ? 2000 : 0);
  }

  onCheckLocalPrinter() {
    this.isLocalPrintersAvailable = this.interactionType != InteractionType.User && this.localService.userDevicePrinterSetupWrapper.devicePrinterSetups.filter(x => x.BusinessId == this.businessId && x.Status == Status.Success && x.IsOn && (x.DevicesTemplates.filter(x => x.TemplateOptions.length > 1).length > 0 || x.PrinterNames.length > 1)).length > 0;

    if (this.isLocalPrintersAvailable) {
      if (this.localService.isOfflineServiceAvailable == undefined) {
        this.offlineService.isServiceAvailable(this.businessId).subscribe(result => {
          this.localService.isOfflineServiceAvailable = result.status == Status.Success;
          this.isLocalPrintersAvailable = this.localService.isOfflineServiceAvailable;
        }, error => {
          this.localService.isOfflineServiceAvailable = false;
          this.isLocalPrintersAvailable = false;
        });
      } else if (!this.localService.isOfflineServiceAvailable) {
        this.isLocalPrintersAvailable = false;
      }
    }
  }

  onGetBusiness(isForce = false) {
    if (this.business == null || isForce) {
      this.isDedicatedStorageAvailable = this.localService.isDedicatedStorageAvailable(this.businessId);
      this.sellerManagementService.getBusiness(this.businessId).subscribe(result => {
        this.business = result;
        this.printingLanguage = this.business.content?.v1 ?? this.localService.getDefaultPrintingLanguage(this.businessId);
        this.serviceTaxPercentage = parseFloat(this.business.content?.v25 || '0');
        this.isNotConsiderTax = this.business.businessEnabledOptions && this.business.businessEnabledOptions.filter(x => x.key == BusinessEnabledOption.ConsiderBaseAmountAsTaxInCludedAmount && x.isSelected).length > 0;

        let bizTaxesFull: KeyValueIdGroup[] = [];
        const taxesCategories = this.business.taxesFull;
        if (taxesCategories && taxesCategories.length > 0) {
          taxesCategories.forEach(taxes => {
            let bizTaxes: KeyValueId[] = [];
            taxes.values.filter(tax => tax.v3).forEach(tax => {
              bizTaxes.push({ key: tax.v4, value: tax.v3 } as KeyValueId);
            });

            bizTaxesFull.push({ key: taxes.key, values: bizTaxes } as KeyValueIdGroup);
          });
        }
        this.businessTaxes = bizTaxesFull;

        if (taxesCategories && taxesCategories.length > 0) {
          const taxes = taxesCategories[0].values;
          let taxTitles: KeyValueId[] = [];
          if (taxes && taxes.length > 0) {
            taxes.forEach(tax => {
              taxTitles.push({ key: tax.v4, value: tax.v1 } as KeyValueId);
            });
          }
          this.taxTitles = taxTitles;
        }
      });
    }
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight(10);
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this.localService.tokenNumber = '';
  }

  onLoad(isForceRefresh = false, isShowSpinner = true) {
    this.onShowHideButton(3);
    if (this.billingMode == BillingMode.Receipt)
      this.searchItems = null;
    if (this.billingId != '0' && this.billingId != '') {
      this.billingManagementService.getBilledProducts(this.billingId, '', false, false, false, isShowSpinner).subscribe(result => {
        this.initialization = result.initialization;
        if (this.initialization.isProductAvailable) {
          if (this.interactionType == InteractionType.User)
            this.initialization.paymentMethods = this.initialization.paymentMethods.filter(x => x.key == PaymentType.WalletWithCompany.toString());
          delete result['initialization'];
          if ((result.bill.v4 && result.bill.v4 != '0') || result.status == BillingStatus.Delivered) {
            if (this.interactionType != 1) {
              result.products.filter(item => item.details.v7 && item.details.v7 == '0').forEach(x => {
                x.details.isSelected = false;
              });
            }
          }
          this.billedItems = result;
          if (this.billedItems.bill.v13) {
            this.selectedCustomerType = '2';
            if (this.interactionType == InteractionType.User)
              this.localService.setBasicParamCustomerBusiness(this.billedItems.bill.v13);
          }
          this.txtAdjustment = !this.billedItems.bill.v18 ? null : parseFloat(this.billedItems.bill.v18);
          this.txtDiscount = !this.billedItems.bill.v20 ? null : parseFloat(this.billedItems.bill.v20);
          this.onSetAfterBilledProductsLoad();
          this.onTotal();
          this.onCheckAppointmentType();
          this.onOpenDeliveryAddress();
          this.onCheckAddOrDeleteProducts();
          this.ensureAllProducts(isForceRefresh);
          this.localService.onFocusNextInput(this.elementIds.product_dd, FocusInputType.NgxDropDown);
          this.localService.tokenNumber = this.billedItems.bill.v2;
          if (this.billedItems.isExcluded && !this.isExcluded) {
            this.isExcluded = this.billedItems.isExcluded;
            this.ensureAllProducts(true);
          }
          this.onCheckBusinessEnabledOptions();
        } else {
          this.onRoute(3);
        }
      });
    } else {
      this.billingManagementService.getInitialization(this.businessId).subscribe(result => {
        this.initialization = result;
        if (this.initialization.isProductAvailable) {
          this.billedItems = {
            status: BillingStatus.New,
            products: [],
            isActionsAllowed: true,
            bill: {
              v2: '', //Token
              v3: this.initialization.businessTypes[0].key, //Business Type
              v4: '0',
              v7: '',
              v8: this.localService.lastBillDeliveryType ? this.localService.lastBillDeliveryType.toString() : this.initialization.deliveryTypes[0].key
            },
            businessTaxes: this.businessTaxes,
            taxTitles: this.taxTitles,
            isNotConsiderTax: this.isNotConsiderTax,
            isExcluded: this.isExcluded
          };
          this.localService.tokenNumber = this.billedItems.bill.v2;
          this.onCheckAddOrDeleteProducts();
          this.ensureAllProducts(isForceRefresh);
          this.onCheckRedirectedBarCode();
          this.onCheckBusinessEnabledOptions();
        } else {
          this.onRoute(3);
        }
      });
    }
  }

  onCheckAddOrDeleteProducts() {
    this.isAddOrDeleteProduct = this.billedItems.isActionsAllowed && (this.billedItems.status == BillingStatus.New || this.billedItems.status == BillingStatus.Draft || this.billedItems.status == BillingStatus.Submitted || (this.isAllowToModifyOnAcceptedStatus && !this.isInventoryEnabled)) && this.billedItems.bill.v4 == '0';
  }

  onCheckWsBusinesEmitDetection() {
    this.wsUserService.onEmitDetected(RegisterName.BusinessEmitDetected).subscribe((res: EmitResponse) => {
      if (this.billingId && this.billingId != '' && this.billingId != '0' && this.billingId == res.result.billingId) {
        setTimeout(() => {
          switch (res.emitType) {
            case EmitType.BillingStatusUpdated: {
              if (this.userId != res.result.statusUpdatedBy) {
                if (this.billedItems.status && res.result.status != 0
                  || (this.billedItems.bill.v4 == '0' && res.result.isPaid)) {
                  this.onLoad();
                }
              }
            } break;
            case EmitType.BillingAction:
            case EmitType.BillingAmountPaid: {
              if (this.userId != res.result.statusUpdatedBy) {
                this.onLoad();
              }
            } break;
            case EmitType.BillBrnUpdated: {
              this.onLoad();
            } break;
          }
        }, 500);
      }
    });
  }

  onPaymentProccesed(e: any) {
    const status = e as Status;
    if (status == Status.Success) {
      this.onAfterAmountPaid();
    }
  }

  ensureAllProducts(isForceRefresh = false) {
    if (!this.initialization.isShowAllElligible) {
      this.billingMode = BillingMode.Receipt;
    }
    if (this.billedItems) {
      if (this.lastBusinessId != this.businessId || isForceRefresh) {
        this.allProducts = null;
        if (this.initialization.isShowAllElligible) {
          this.productManagementService.getAllProductsToDisplay(this.businessId, this.billingId, this.billedItems.bill.v3, this.ctryCode, this.isExcluded).subscribe(result => {
            this.allProducts = result;
            this.isActiveProductAvailable = this.allProducts.filter(x => x.isSelected).length > 0;
            if (this.billingMode != BillingMode.Receipt)
              this.onSearch();
          });
        }
      } else {
        if (this.billingMode != BillingMode.Receipt)
          this.onSearch();
      }
      this.lastBusinessId = this.businessId;
      if (this.billingMode == BillingMode.QuickPick) {
        //this.quickSearchKey = '';
        //this.localService.onSetInput(this.elementIds.txt_quick_search, FocusInputType.TextBox);
      }
    }
  }


  onCheckAppointmentType(isForce = false) {
    if (this.billedItems.isActionsAllowed) {
      if (isForce || (this.billedItems.bill.v2 && this.billedItems.bill.v8 == DeliveryType.Appointment.toString() && this.billedItems.bill.v14 == '0')) {
        const modalRef = this.modalService.open(EditAppointmentComponent, { size: 'sm' });
        modalRef.componentInstance.id = this.billedItems.bill.v14 == '0' ? '' : this.billedItems.bill.v14;
        modalRef.componentInstance.businessId = this.businessId;
        modalRef.componentInstance.appointmentType = AppointmentType.Receipt;
        modalRef.componentInstance.customerId = this.billedItems.bill.v5;
        modalRef.componentInstance.providerId = this.billedItems.bill.v6;
        modalRef.componentInstance.notes = this.billedItems.bill.v2;
        modalRef.componentInstance.appointmentChildId = this.billingId;
        modalRef.componentInstance.interactionType = this.interactionType;
        modalRef.result.then((result) => {
          if (result.event == TriggeredEvent.Ok) {
            this.onAction(ActionType.UpdateAppointment, result.data);
          }
        });
      }
    }
  }

  onUserTypeSwitched() {
    this.selectedCustomerType = this.selectedCustomerType == '1' ? '2' : '1';
    setTimeout(() => {
      let element: HTMLButtonElement = document.getElementById(this.selectedCustomerType == '1' ? this.elementIds.brn_search_billing_customer : this.elementIds.brn_search_billing_customer_business) as HTMLButtonElement;
      if (element) {
        element.click();
      }
    }, 500);
  }

  onReset(isResetSelectedCategory?: boolean) {
    let lastAllowDuplicateValue = this.wrapper == undefined || this.wrapper == null ? true : this.wrapper.is_allow_duplicate;
    this.searchItems = null;
    this.localService.billQty = null;
    this.selectedMeasurement = '';
    this.selectedPrice = null;
    this.selectedPrices = [];
    this.selectedBatchId = '';
    this.measurmentTypes = [];
    this.selectedMeasurementType = '';
    this.wrapper = {
      productId: '',
      qty: null,
      is_allow_duplicate: lastAllowDuplicateValue,
      brn: null,
      brn_name: '',
      brn_language: '',
      brn_with: null,
      brn_name_with: '',
      brn_language_with: '',
    };
    if (this.billedItems && this.billingId == '0') {
      this.billedItems.bill.v5 = '';
      this.billedItems.bill.v6 = '';
      this.billedItems.bill.v13 = '';
    }
    this.total = 0;
    this.isShowSelected = false;
    if (isResetSelectedCategory) {
      this.quickSearchKey = '';
      this.selectedCategory = '0';
    }
    this.localService.onFocusNextInput(this.elementIds.product_dd, FocusInputType.NgxDropDown);
  }

  onSelectBillingMode() {
    this.billingMode = parseInt(this.selectedBillingMode);
    this.onCheckDeviceSettings();
    this.onSearch();
  }

  isReceiptMode = false;
  lastSearchText = '';
  onSearch(searchText = '') {
    searchText = searchText.trim();
    this.lastSearchText = searchText;
    const billingMode = this.billingMode;
    this.isReceiptMode = billingMode == BillingMode.Receipt;

    this.selectedPrice = null;
    this.selectedPrices = [];
    this.selectedBatchId = '';
    this.measurmentTypes = [];
    this.selectedMeasurementType = '';

    switch (billingMode) {
      case BillingMode.Receipt: {
        setTimeout(() => {
          if (searchText.length >= 3) {
            if (this.lastSearchText == searchText) {
              let decodedQrCode = this.localService.getDecodedQrCode(searchText);
              if (decodedQrCode.isValid) {
                this.onSearchBarCode(decodedQrCode);
              } else {
                this.onSearchProduct(searchText);
              }
            }
          }
        }, this.isReceiptMode ? 200 : 0);
      } break;
      case BillingMode.ShowAll:
      case BillingMode.QuickPick: {
        this.onSetEmptySearchItems();
        if (this.billedItems && this.searchItems.length > 0 && this.billedItems.products) {
          this.billedItems.products.forEach(selPrd => {
            let item = this.searchItems.find(x => x.key == selPrd.productId);
            if (item) {
              item.v1 = selPrd.details.v1;
              item.v12 = selPrd.details.key;
              item.v14 = selPrd.details.v14;
            }
          });
        }
        if (billingMode == BillingMode.QuickPick)
          this.onGetProductCategory(this.selectedCategory);
      } break;
    }
  }

  onSetEmptySearchItems() {
    const selectedKeys: string[] = this.isAddOrDeleteProduct ? [] : this.billedItems.products.map(x => x.productId);
    const searchItems = this.isAddOrDeleteProduct ? this.allProducts.filter(x => x.isSelected) : this.allProducts.filter(x => selectedKeys.indexOf(x.key) > -1);
    this.searchItems = JSON.parse(JSON.stringify(searchItems));
  }

  onGetProductCategory(selectedCategory = null) {
    this.sellerManagementService.getProductCategories(this.businessId).subscribe(result2 => {
      let categoryIds: string[] = (this.searchItems.filter(x => x.values).map(x => x.values)).flat();
      this.productCategories = result2.filter(x => categoryIds.indexOf(x.key) > -1);
      this.onSetProductCategories();
      if (selectedCategory == null)
        this.onSelectProductCategory(this.interactionType == InteractionType.User ? '1' : '0');
    });
  }

  onSelectProductCategory(categoryId) {
    this.selectedCategory = categoryId;
  }

  onSearchProduct(strSearchKey, isBarCode = false) {
    if (!this.isRequestProcessing || !this.isReceiptMode) {
      this.isShowSpinnerCount++;
      this.isRequestProcessing = true;
      this.productManagementService.getSearchedProduct(this.businessId, strSearchKey, isBarCode).subscribe(result => {
        setTimeout(() => {
          this.isRequestProcessing = false;
        }, this.isReceiptMode ? 100 : 0);
        this.isShowSpinnerCount--;
        if (!isBarCode) {
          isBarCode = result.length == 1 && result[0].v15 == '1';
          strSearchKey = result[0].key
        }
        this.searchItems = result;
        if (isBarCode) {
          this.isRequestProcessing = false;
          this.onSaveBilling(strSearchKey, 1, true);
          this.localService.onSetInput(this.elementIds.product_dd, FocusInputType.NgxDropDown);
        }
      });
    }
  }

  onQrScanned(value) {
    //let qr = this.localService.getDecodedQrCode(value);
    if (this.billingMode == BillingMode.Receipt) {
      this.onSearch(value);
    } else {
      this.productManagementService.getProductIdOfBarCode(this.businessId, value).subscribe(result => {
        if (result.status == Status.Success) {
          const item = this.searchItems.find(x => x.key == result.id);
          if (item) {
            this.selectedCategory = '1';
            this.onAdjustQuickQty(2, item.key, item.v1, item.v15, item.v5);
          }
        }
      });
    }
  }

  onCheckRedirectedBarCode() {
    let decodedQrCode = this.localService.getQrCodeRedirected();
    if (decodedQrCode != null) {
      this.onSearchBarCode(decodedQrCode);
    } else {
      this.localService.onFocusNextInput(this.elementIds.product_dd, FocusInputType.NgxDropDown);
    }
  }

  onSearchBarCode(decodedQrCode: DecodedQrCode) {
    if (!decodedQrCode.quantity || decodedQrCode.quantity == 0)
      decodedQrCode.quantity = 1;
    if (decodedQrCode.quantity != 0) {
      this.onSaveBilling(decodedQrCode.isValid ? (decodedQrCode.isInternalBarCode ? decodedQrCode.value : decodedQrCode.productId) : decodedQrCode.rawData, decodedQrCode.quantity, true, !decodedQrCode.isValid, decodedQrCode.value);
    } else {
      this.onSearchProduct(decodedQrCode.isInternalBarCode ? decodedQrCode.value : decodedQrCode.productId, true);
    }
  }

  onBringItemOnTop(product: BilledProduct) {
    if (this.billedItems.products.filter(x => x.productId == product.productId && x.details.v15 == product.details.v15 && x.details.v5 == product.details.v5).length > 0)
      this.billedItems.products = this.billedItems.products.filter(x => !(x.productId == product.productId && x.details.v15 == product.details.v15 && x.details.v5 == product.details.v5));
    this.billedItems.products.unshift(product);
  }

  onResetQuantity(productId: string, batchId: string) {
    var billedItem = this.billedItems.products.find(x => x.productId == productId && x.details.v15 == batchId);
    const updatedQty = billedItem ? (billedItem.details.v18 ?? null) : null;

    if (billedItem) {
      billedItem.details.v1 = updatedQty;
    }

    if (this.searchItems && this.searchItems.length > 0) {
      var searchItem = this.searchItems.find(x => x.key == productId && x.v15 == batchId);
      if (searchItem) {
        searchItem.v1 = updatedQty;
      }
    }

    this.localService.showInformation(this.localService.languageContent.billing.insufficient_stock, true);
  }

  onBringItemOnTopByKey(productKey: string, batchId: string) {
    let product = this.billedItems.products.find(x => x.productId == productKey && x.details.v15 == batchId);
    if (product) {
      this.billedItems.products = this.billedItems.products.filter(x => !(x.productId == product.productId && x.details.v15 == batchId));
      this.billedItems.products.unshift(product);
    }
  }

  onSelectBatchId() {
    this.selectedPrice = this.selectedPrices.find(x => x.batchId == this.selectedBatchId);
    this.localService.onFocusNextInput(this.elementIds.qty, FocusInputType.TextBox);
  }

  onProductSelect(batchId: string = '') {
    if (this.wrapper.productId && this.wrapper.productId != '') {
      this.measurmentTypes = [];
      this.selectedMeasurementType = '';

      const selecetdItem = this.searchItems.find(x => x.key == this.wrapper.productId);
      if (selecetdItem && selecetdItem.values && selecetdItem.values.length > 0) {
        this.measurmentTypes = JSON.parse(JSON.stringify(this.localService.measurementTypes.filter(x =>
          selecetdItem.values.includes(x.key) || x.key == selecetdItem.v5
        )));
        this.measurmentTypes.find(x => x.key == selecetdItem.v5).isSelected = true;
        this.selectedMeasurementType = selecetdItem.v5;
      }

      const measurementType = (this.onGetMeasumentType() ?? parseInt(selecetdItem?.v5 ?? '0')).toString();

      if ((!this.hasValidBatchDetails || batchId)
        && this.billedItems.products.length > 0
        && this.billedItems.products.filter(x => x.productId == this.wrapper.productId && x.details.v15 == batchId && x.details.v5 == measurementType).length > 0) {
        let product = this.billedItems.products.filter(x => x.productId == this.wrapper.productId && x.details.v15 == batchId && x.details.v5 == measurementType)[0];
        this.onBringItemOnTop(product);
        this.localService.onFocusNextInput(this.elementIds.qty + '_' + this.wrapper.productId + '_' + measurementType, FocusInputType.TextBox, true);
        if (!(this.measurmentTypes.length > 0)) {
          this.wrapper.productId = '';
          this.searchItems = null;
          this.localService.billQty = null;
          this.selectedPrices = [];
          this.selectedPrice = null;
          this.selectedBatchId = '';
        }
      } else {
        this.selectedPrices = [];
        this.selectedPrice = null;
        this.selectedBatchId = '';
        this.onSetPrice();
      }
    }
  }

  onGetMeasumentType(isIncludeParentType?: boolean): number | undefined {
    let measurementType: number | undefined = undefined;
    if (this.selectedMeasurementType) {
      const selecetdItem = this.measurmentTypes.find(x => x.key == this.selectedMeasurementType);
      if (selecetdItem && (isIncludeParentType || !selecetdItem.isSelected)) {
        measurementType = parseInt(this.selectedMeasurementType);
      }
    }
    return measurementType;
  }

  onSelectMeasurementType() {
    const measurementType = this.onGetMeasumentType(true).toString();
    if (this.billedItems.products.length > 0
      && this.billedItems.products.filter(x => x.productId == this.wrapper.productId && x.details.v5 == measurementType).length > 0) {
      let product = this.billedItems.products.filter(x => x.productId == this.wrapper.productId && x.details.v5 == measurementType)[0];
      this.onBringItemOnTop(product);
      this.localService.onFocusNextInput(this.elementIds.qty + '_' + this.wrapper.productId + '_' + measurementType, FocusInputType.TextBox, true);
    } else {
      this.onSetPrice();
    }
  }

  onSetPrice() {
    if (this.searchItems.length > 0) {
      const searchItem = this.searchItems.find(x => x.key == this.wrapper.productId);
      if (searchItem) {
        if (searchItem.v19 == '0') {
          this.localService.showInformation(this.localService.languageContent.billing.item_inactive, true);
          this.onReset();
          return;
        }
      }
    }

    const measurementType = this.onGetMeasumentType();

    this.productManagementService.getPrice(this.wrapper.productId, this.billedItems.bill.v3, this.hasValidBatchDetails, this.isExcluded, this.businessId, undefined, measurementType).subscribe(result => {
      this.selectedPrices = result;
      if (result.length == 1) {
        this.selectedPrice = result[0];
        this.selectedBatchId = result[0].batchId;
        this.selectedMeasurement = " (" + this.onGetName(3, measurementType ? measurementType.toString() : this.searchItems.find(x => x.key == this.wrapper.productId).v5) + ")";
        this.localService.onFocusNextInput(this.elementIds.qty, FocusInputType.TextBox);
      } else if (this.hasValidBatchDetails) {
        if (result.length == 2) {
          this.selectedPrice = result[1];
          this.selectedBatchId = result[1].batchId;
          this.localService.onFocusNextInput(this.elementIds.qty, FocusInputType.TextBox);
        } else if (result.length > 2) {
          this.selectedPrice = result[1];
          this.selectedBatchId = result[1].batchId;
          this.localService.onFocusNextInput(this.elementIds.qty, FocusInputType.TextBox);
          //this.localService.onFocusNextInput(this.elementIds.batch_dd, FocusInputType.NgxDropDown);
        }
      }
    });
  }

  billingValidation: BillingValidation[] = [];

  onGetBillingValidation(): BillingValidation[] {
    var rtn: BillingValidation[] = [];

    if (this.hasValidBatchDetails) {
      rtn.push(BillingValidation.BusinessHasValidBatchDetails);
    }

    if (this.isNotConsiderTax) {
      rtn.push(BillingValidation.NotConsiderTax);
    }

    if (this.localService.isBusinessHasPurchaseEntry(this.businessId)) {
      rtn.push(BillingValidation.BusinessHasPurchaseEntry);
    }

    if (this.isInventoryEnabled) {
      rtn.push(BillingValidation.BusinessHaInventory);
    }
    this.billingValidation = rtn;
    return rtn;
  }

  isRequestProcessing = false;
  onSaveBilling(productId = '', qty = null, isBarCode = false, isRawBarCode = false, serialNumber = '') {
    if (!this.isRequestProcessing || !this.isReceiptMode) {
      let max_items_per_receipt = this.localService.onGetUsageLimit(UsageLimitType.MaximumItemsPerReceipt);
      if (max_items_per_receipt == 0 || max_items_per_receipt > this.billedItems.products.length) {
        let finalQty = this.localService.billQty;
        let finalProductId = this.wrapper.productId;
        const measurementType = this.onGetMeasumentType();
        if (productId != '') {
          finalProductId = productId;
          finalQty = qty ?? 0;
        }
        finalQty = finalQty ?? 0;
        if (finalProductId != '') {
          if (finalQty > 0) {
            let wrapperBill = {
              key: this.billingId == '0' ? '' : this.billingId,
              v1: this.businessId,
              v2: '',
              v3: this.billedItems.bill.v3,
              v4: this.billingId == '0' ? this.userId : '',
              v5: this.billedItems.bill.v7,
              v6: this.billedItems.bill.v8,
              v7: this.billedItems.bill.v5, //Customer
              v8: this.billedItems.bill.v13, //Business Customer
              v9: this.billedItems.bill.v6, //Service By
              v10: this.isExcluded ? '1' : '0',
              v11: measurementType ? measurementType.toString() : undefined,
              v12: this.serviceTaxPercentage.toString()
            } as KeyValues15;
            let wrapperProduct = {
              key: (isBarCode ? ('dtbrcdvl' + (isRawBarCode ? '0' : '1') + '-') : '') + finalProductId,
              v1: finalQty.toString(),
              v2: serialNumber,
              v3: this.selectedBatchId
            } as KeyValues3;
            const batchId = wrapperProduct.v3;

            const billWrapper: AddBillWrapper = {
              bill: wrapperBill,
              product: wrapperProduct,
              bizTaxes: this.billedItems.businessTaxes,
              tableId: this.tableId,
              billingValidations: this.onGetBillingValidation(),
              providerId: this.billedItems.bill.v6,
            }

            this.isRequestProcessing = true;
            this.billingManagementService.addBillingDetail(billWrapper).subscribe(result => {
              setTimeout(() => {
                this.isRequestProcessing = false;
              }, this.isReceiptMode ? 100 : 0);

              if (result != null) {
                if (result.isRequestedForSearch) {
                  this.onSearchProduct(productId);
                } else {
                  switch (result.status) {
                    case Status.UnAvailable: {
                      this.localService.showInformation(this.localService.languageContent.billing.item_inactive, true);
                      this.onReset();
                      if (isBarCode) {
                        this.searchItems = null;
                        this.localService.onSetInput(this.elementIds.product_dd, FocusInputType.NgxDropDown);
                      }
                    } break;
                    case Status.Updated: {
                      this.onAfterQtyUpdate(result.product.productId, result.id, batchId);
                      if (isBarCode) {
                        this.searchItems = null;
                        this.localService.onSetInput(this.elementIds.product_dd, FocusInputType.NgxDropDown);
                      }
                    } break;
                    case Status.InventoryRequired: {
                      this.onResetQuantity(productId, billWrapper.product.v3);
                      if (!this.billingId || this.billingId.length < 5) {
                        this.router.navigate(['/billing' + this.localService.basicParamsString, this.businessId, result.billingId]);
                      }
                    } break;
                    case Status.Success: {
                      const billingMode: BillingMode = this.billingMode;
                      switch (billingMode) {
                        case BillingMode.ShowAll:
                        case BillingMode.QuickPick: {
                          let item = this.searchItems.find(x => x.key == finalProductId);
                          if (item) {
                            item.v12 = result.product.details.key;
                          }
                          //this.quickSearchKey = '';
                          //this.localService.onSetInput(this.elementIds.txt_quick_search, FocusInputType.TextBox);
                        } break;
                      }
                      //this.onSetTax(result.product.productId, result.price);
                      if (this.billingId == '0' || this.billingId == '') {
                        this.billedItems.status = BillingStatus.Draft;
                        if (this.tableId && this.tableId.length > 5) {
                          this.router.navigate(['/billing-tbl' + this.localService.basicParamsString, this.businessId, result.billingId, this.tableId]);
                        } else {
                          this.router.navigate(['/billing' + this.localService.basicParamsString, this.businessId, result.billingId]);
                        }

                      } else {
                        this.onBringItemOnTop(result.product);
                        if (!isBarCode && qty == null)
                          this.onReset();
                      }

                      if (isBarCode) {
                        this.searchItems = null;
                        this.localService.onSetInput(this.elementIds.product_dd, FocusInputType.NgxDropDown);
                      }
                      this.onSetProducTax(result.product.productId, result.product.taxesFull);
                      this.onSetAfterBilledProductsLoad();
                      this.onTotal();
                    } break;
                    case Status.NotAllowed: {
                      this.billedItems.isActionsAllowed = false;
                    } break;
                    case Status.DataRequired: {
                      this.localService.showMessage(this.localService.languageContent.billing.price_required);
                    } break;
                    case Status.LimitExceeded: {
                      if (isBarCode) {
                        this.searchItems = null;
                        this.localService.onSetInput(this.elementIds.product_dd, FocusInputType.NgxDropDown);
                      }
                    } break;
                    case Status.Duplicate: {
                      this.onProductSelect(this.selectedBatchId);
                    } break;
                  }
                }
              }
            });
          } else {
            this.onRemoveProduct(finalProductId, this.selectedBatchId, measurementType ? measurementType.toString() : '');
          }
        }
      } else {
        this.localService.showMessage(this.localService.languageContent.billing.limit_exceeded);
      }
    }
  }

  onSetTax(productId: string, pricing: PricingManagementWrapper) {
    /* if (!this.billedItems.pricings) {
      this.billedItems.pricings = [] as ProductPricing[];
    }
    const item = this.billedItems.pricings.find(x => x.productId == productId);
    if (!item) {
      this.billedItems.pricings.push({ productId: productId, price: pricing } as ProductPricing);
    } */
  }

  onRoute(index, key?: string) {
    switch (index) {
      case 1: {
        if (this.tableId && this.tableId.length > 5) {
          this.router.navigate(['/billing-tbl' + this.localService.basicParamsString, this.businessId, 0, this.tableId]);
        } else {
          this.router.navigate(['/billing' + this.localService.basicParamsString, this.businessId, 0]);
        }
      } break;
      case 2: {
        this.billingManagementService.copyBill(this.billingId, this.businessId).subscribe(result => {
          if (result.status == Status.Success) {
            this.localService.showInformation(this.localService.languageContent.billing.bill_copied);
            if (this.tableId && this.tableId.length > 5) {
              this.router.navigate(['/billing-tbl' + this.localService.basicParamsString, this.businessId, result.id, this.tableId]);
            } else {
              this.router.navigate(['/billing' + this.localService.basicParamsString, this.businessId, result.id]);
            }
          }
        });
      } break;
      case 3: {
        if (this.localService.languageContent.billing)
          this.localService.showInformation(this.localService.languageContent.billing.no_products);
        if (this.interactionType != InteractionType.User) {
          this.router.navigate(['/products/' + this.ctryCode, this.userId, this.interactionType, this.businessId]);
        }
      } break;
      case 4: {
        this.router.navigate(['/reservation' + this.localService.basicParamsString, this.businessId]);
      } break;
      case 5: {
        if (this.route.snapshot.pathFromRoot.length > 0) {
          this.localService.lastUrl = this.route.snapshot.pathFromRoot[0]['_routerState'].url;
        }
        this.router.navigate(['/receipt-files' + this.localService.basicParamsString, this.businessId, this.billingId]);
      } break;
      case 6: {
        this.router.navigate(['/receipt-custom-labels' + this.localService.basicParamsString, this.businessId, this.billingId]);
      } break;
    }
  }

  onRemoveProduct(productId: string = '', batchId: string = '', measurmentTypeStr: string = '') {
    if (productId != '') {
      this.billingManagementService.removeBillingDetail(this.billingId, productId, batchId, measurmentTypeStr ? parseInt(measurmentTypeStr) : undefined).subscribe(result => {
        if (result.status == Status.Success) {
          this.billedItems.products = this.billedItems.products.filter(x => !(x.productId == result.id && x.details.v15 == batchId && x.details.v5 == measurmentTypeStr));
          if (this.searchItems && this.searchItems.length > 0) {
            let item = this.searchItems.find(x => x.key == productId && x.v5 == measurmentTypeStr);
            if (item) {
              item.v1 = null;
              item.v12 = '';
              item.v14 = '';
            }
          }
        }
        this.onTotal();
      });
    }
    if (this.billingMode == BillingMode.Receipt) {
      this.selectedMeasurement = '';
      this.selectedPrice = null;
      this.selectedPrices = [];
      this.selectedBatchId = '';
      this.measurmentTypes = [];
      this.selectedMeasurementType = '';
      this.localService.onFocusNextInput(this.elementIds.product_dd, FocusInputType.NgxDropDown);
    }
  }

  onShowReturnedItems(isViewMode) {
    if (this.billedItems.isActionsAllowed) {
      let selectedProducts = [];
      if (!isViewMode) {
        selectedProducts = this.billedItems.products.filter(item => item.details.isSelected && item.details.v7 == '0');
        if (selectedProducts.length == 0) {
          selectedProducts = this.billedItems.products.filter(item => item.details.v7 == '0');
        }
      }
      if (selectedProducts.length > 0 || isViewMode) {
        const modalRef = this.modalService.open(ReturnProductsComponent, { size: 'lg' });
        modalRef.componentInstance.products = selectedProducts;
        modalRef.componentInstance.billingId = this.billingId;
        modalRef.componentInstance.isViewMode = isViewMode;
        modalRef.componentInstance.intractionType = this.interactionType;
        modalRef.result.then((result) => {
          if (result.event == TriggeredEvent.Ok && !isViewMode) {
            this.onLoad();
          }
        });
      }
    }
  }

  isProductAvailableForReturn(): boolean {
    if (this.isDisableReturnInBilling) {
      return false;
    }
    return this.billedItems && (this.isAmountPaid() || this.billedItems.status == BillingStatus.Delivered) && this.billedItems.products.filter(item => item.details.v7 && item.details.v7 == '0').length > 0;
  }

  onSerialNumberMapping(productId, qty, batchId) {
    if (this.billedItems.isActionsAllowed) {
      const modalRef = this.modalService.open(SerialNumbersMappingComponent);
      modalRef.componentInstance.productId = productId;
      modalRef.componentInstance.qty = qty;
      modalRef.componentInstance.batchId = batchId;
      modalRef.componentInstance.billingId = this.billingId;
      modalRef.componentInstance.isViewMode = ![BillingStatus.Draft, BillingStatus.Submitted].includes(parseInt(this.billedItems.status.toString()));
      modalRef.componentInstance.intractionType = this.interactionType;
      modalRef.result.then((result) => {
        if (result.event == TriggeredEvent.Ok) {
          this.billedItems.products.find(x => x.productId == productId && x.details.v15 == batchId).details.v8 = result.data.length;
          //this.onLoad();
        }
      });
    }
  }

  isMinimumQtyAvailable(productId: string, batchId: string) {
    let rtn = true;
    if (this.billingDetailsSimple && this.billingDetailsSimple.lessMinumumQuantity) {
      rtn = this.billingDetailsSimple.lessMinumumQuantity.filter(x => x.key == productId && x.s_value == batchId).length == 0;
    }
    return rtn;
  }

  getMinimumQty(productId: string, batchId: string) {
    let rtn = 0;
    if (this.billingDetailsSimple && this.billingDetailsSimple.lessMinumumQuantity) {
      let item = this.billingDetailsSimple.lessMinumumQuantity.find(x => x.key == productId && x.s_value == batchId);
      if (item) {
        rtn = parseFloat(item.value);
      }
    }
    return rtn;
  }

  serialNumberRequiredStatus: BillingStatus[] = [BillingStatus.Accepted, BillingStatus.Delivered, BillingStatus.OutForDeliver, BillingStatus.Ready];
  onUpdateStatus(status: BillingStatus, isShowSubmittedMessage?: boolean) {
    this.onShowHideButton(3);
    let isSerialNumbersAdded = false;
    if (this.serialNumberRequiredStatus.indexOf(status) > -1) {
      isSerialNumbersAdded = this.billedItems.products.filter(x => x.details.v8 != '-1' && x.details.v8 != x.details.v1).length == 0;

    } else {
      isSerialNumbersAdded = true;
    }
    if (isSerialNumbersAdded) {
      if (this.isAllowToModifyOnAcceptedStatus && status == BillingStatus.Accepted && !(this.billedItems.status == BillingStatus.Draft || this.billedItems.status == BillingStatus.Submitted)) {
        status = BillingStatus.ReAccepted;
      }
      this.billingManagementService.updateBillingStatus(this.billingId, status, this.tableId).subscribe(result => {
        if (status == BillingStatus.ReAccepted) {
          this.localService.showInformationByStatus(result.responseStatus.status);
        }
        else {
          this.billingDetailsSimple = result;
          if (this.billingDetailsSimple && this.billingDetailsSimple.responseStatus.status == Status.NotAllowed) {
            this.billedItems.isActionsAllowed = false;
          } else {
            if (this.billingDetailsSimple && this.billingDetailsSimple.responseStatus.status == Status.Success) {
              this.billedItems.status = this.billingDetailsSimple.status;
              this.billedItems.bill.v2 = this.billingDetailsSimple.bill.v2;
              this.localService.tokenNumber = this.billedItems.bill.v2;
              this.onCheckAddOrDeleteProducts();
              this.ensureAllProducts();
              if (status == BillingStatus.Submitted) {
                if (isShowSubmittedMessage) {
                  this.onShowSubmittedMessage();
                }
              } else {
                this.onCheckAppointmentType();
              }
              this.onOpenDeliveryAddress();
            } else {
              this.onShowProductValidation(this.billingDetailsSimple.responseStatus.status, this.billingDetailsSimple.invalidProducts);
            }
            if (this.billingDetailsSimple && this.billingDetailsSimple.responseStatus.status == Status.MinimumRequired) {
              this.onMinimumQuantityNeed();
            }
            if (this.billingDetailsSimple.products && this.billingDetailsSimple.products.length > 0)
              this.billedItems.products = this.billingDetailsSimple.products;
          }
        }
      });
    } else {
      this.localService.showMessage(this.localService.languageContent.billing.serial_num_required);
    }
  }

  isActionPopupOpen: boolean = false; actionTitle: string = ''; moreActionItems: KeyValues5[] = [];
  onOpenMoreActionForQuickPickCompact() {
    this.moreActionItems = [
      {
        isSelected: true,
        key: '1',
        v1: this.localService.languageContent.billing['paid'],
        v2: 'credit_card',
        v3: this.billingId,
        isReadonly: !(this.total > 0 && this.isBusinessOptionVisible(6) && this.isFooterbarShow && this.initialization.paymentMethods && this.initialization.paymentMethods.length > 0 && this.billedItems.status != 11 && this.billedItems.bill.v4 == '0') || this.isAmountPaid()
      } as KeyValues5,
      {
        isSelected: true,
        key: '2',
        v1: this.localService.languageContent.billing['print'],
        v2: 'print',
        v3: this.billingId,
        isReadonly: !(!(this.isViewMode && this.isDisablePrintInViewMode) && (this.interactionType == 2 || this.interactionType == 4) && this.isFooterbarShow && this.billingId != '0' && !this.isBusinessOptionVisible(19) && (!this.isDisablePrintOnDraftMode || (this.isDisablePrintOnDraftMode && this.billedItems.status != BillingStatus.Draft)))
      } as KeyValues5
    ];
    this.isActionPopupOpen = true;
  }

  onMoreActionClicked(keyId: KeyValueId) {
    switch (keyId.key) {
      case '1': {
        this.isOpenPaymentModes = true;
      } break;
      case '2': {
        this.onPrint();
      } break;
    }
  }

  onShowSubmittedMessage() {
    this.localService.showMessage(this.localService.languageContent.billing['order_placed'].replace('##TokenNumber##', this.localService.tokenNumber), this.localService.languageContent.billing['order_placed_header'], true);
  }

  onMinimumQuantityNeed() {
    if (this.billingDetailsSimple?.responseStatus) {
      this.localService.showInformationByStatus(this.billingDetailsSimple.
        responseStatus.status, true);
    }

    this.billingDetailsSimple?.lessMinumumQuantity?.forEach(x => {
      this.onBringItemOnTopByKey(x.key, x.s_value);
    });
  }

  onSetProducTax(productId: string, taxesFull?: PricingManagementWrapper) {
    if (taxesFull && this.billedItems.productTaxes) {
      const item = this.billedItems.productTaxes?.find(x => x.content.v5 == productId);
      if (!item) {
        this.billedItems.productTaxes.push(taxesFull);
      }
    }
  }

  onSetAfterBilledProductsLoad() {
    if (this.billedItems) {
      this.billedItems.products.forEach(product => {
        product.details.v25 = product.details.v4;
      });
    }
  }

  onGetRoundOffSelectedPrice(): number {
    let price = this.selectedPrice.price;
    return price;
  }

  onTotal(isTimeDelayRequired = true) {
    this.currencyIcon = this.localService.onGetCurrencyIcon(this.businessId);
    setTimeout(() => {
      if ((this.txtAdjustment && this.txtAdjustment != 0)
        || (this.txtDiscount && this.txtDiscount != 0)) {
        this.total = (this.txtAdjustment ? this.txtAdjustment : 0) - (this.txtDiscount ? this.txtDiscount : 0);
        this.total += this.onGetPriceIncludeTax();
      } else {
        this.total = this.onGetPriceIncludeTax();
      }
    }, isTimeDelayRequired ? 200 : 0);
  }

  onGetPriceIncludeTax(): number {
    const productsToBill = this.billedItems.products.filter(x => !(x.details.v7 && x.details.v7 != '' && x.details.v7 != '0'));
    const totalAmount = GetPriceIncludeTax(productsToBill, this.billedItems.isNotConsiderTax, this.billedItems.businessTaxes);
    const serviceChargeAmount = GetServiceChargeAmount(this.billedItems.bill && this.billedItems.bill.v23?.length > 0 ? parseFloat(this.billedItems.bill.v23) : 0, undefined, productsToBill);

    return parseFloat((totalAmount + serviceChargeAmount + (this.txtAdjustment ? 0 : GetAdjustmentAmount(totalAmount, (this.txtDiscount ? this.txtDiscount : 0), this.billedItems.adjustmentFormulas, this.txtAdjustment))).toFixed(2));
  }

  selectedBillingDetailId: string = ''; isOpenUpdateProductNote: boolean = false;
  productNoteHeader: string = ''; productNoteDescription: string = '';
  onOpenProductNotes(selectedBillingDetailId: string) {
    this.selectedBillingDetailId = selectedBillingDetailId;
    const billingMode: BillingMode = this.billingMode;
    switch (billingMode) {
      case BillingMode.ShowAll:
      case BillingMode.QuickPick: {
        const item = this.searchItems.find(x => x.v12 == this.selectedBillingDetailId);
        if (item) {
          this.productNoteHeader = item.v3;
          this.productNoteDescription = item.v14;
          this.isOpenUpdateProductNote = true;
        }
      } break;
      case BillingMode.Receipt: {
        const item = this.billedItems.products?.find(x => x.details.key == this.selectedBillingDetailId);
        if (item) {
          this.productNoteHeader = item.details.v3;
          this.productNoteDescription = item.details.v14;
          this.isOpenUpdateProductNote = true;
        }
      } break;
    }
  }

  isOpenUpdateStaff: boolean = false; createdByName: string = ''; createdByLanguage: string = ''; staffId: string = '';
  onOpenStaff(selectedBillingDetailId: string) {
    this.selectedBillingDetailId = selectedBillingDetailId;
    const billingMode: BillingMode = this.billingMode;
    switch (billingMode) {
      case BillingMode.ShowAll:
      case BillingMode.QuickPick: {
        const item = this.searchItems.find(x => x.v12 == this.selectedBillingDetailId);
        if (item) {
          this.productNoteHeader = item.v3;
          this.createdByName = item.v20;
          this.createdByLanguage = item.v21;
          this.staffId = item.v22;
          this.isOpenUpdateStaff = true;
        }
      } break;
      case BillingMode.Receipt: {
        const item = this.billedItems.products?.find(x => x.details.key == this.selectedBillingDetailId);
        if (item) {
          this.productNoteHeader = item.details.v3;
          this.createdByName = item.details.v20;
          this.createdByLanguage = item.details.v21;
          this.staffId = item.details.v22;
          this.isOpenUpdateStaff = true;
        }
      } break;
    }
  }

  onUpdateProductNotes(data: KeyValueId) {
    this.onActionBillingDetail(data.key, ActionTypeBillingDetail.UpdateNotes, data.value as string);
  }

  onUpdateStaff(data: KeyValueId) {
    this.onActionBillingDetail(data.key, ActionTypeBillingDetail.UpdateStaff, data.value as string);
  }

  onActionBillingDetail(billingDetailId: string, actionType: ActionTypeBillingDetail, value: string) {
    this.billingManagementService.onActionBillingDetail(billingDetailId, actionType, value).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result && result.status == Status.Success) {
        switch (actionType) {
          case ActionTypeBillingDetail.UpdateNotes: {
            const billingMode: BillingMode = this.billingMode;
            switch (billingMode) {
              case BillingMode.ShowAll:
              case BillingMode.QuickPick: {
                let item = this.searchItems.find(x => x.v12 == this.selectedBillingDetailId);
                if (item) {
                  item.v14 = value;
                }
              } break;
              case BillingMode.Receipt: {
                let item = this.billedItems.products?.find(x => x.details.key == this.selectedBillingDetailId).details;
                item.v14 = value;
              } break;
            }
          } break;
          case ActionTypeBillingDetail.UpdateStaff: {
            const billingMode: BillingMode = this.billingMode;
            switch (billingMode) {
              case BillingMode.ShowAll:
              case BillingMode.QuickPick: {
                let item = this.searchItems.find(x => x.v12 == this.selectedBillingDetailId);
                if (item) {
                  item.v22 = value;
                }
              } break;
              case BillingMode.Receipt: {
                let item = this.billedItems.products?.find(x => x.details.key == this.selectedBillingDetailId).details;
                item.v22 = value;
              } break;
            }
          } break;
        }
      }
    });
  }

  onAction(actionType: ActionType, value: any = null, isShowSpinner: boolean = true) {
    if (this.interactionType == InteractionType.Business) {
      if (this.isAmountPaid() && [ActionType.UpdateAdjustment, ActionType.UpdateDiscountAmount, ActionType.UpdatePaidAmount].includes(actionType)) {
        return false;
      }

      if (this.billingId != '0') {
        switch (actionType) {
          case ActionType.UpdateDeliveryType: {
            this.localService.lastBillDeliveryType = value;
          } break;
        }


        let isSerialNumbersAdded = false;
        if (actionType == ActionType.AmountPaid) {
          isSerialNumbersAdded = this.billedItems.products.filter(x => x.details.v8 != '-1' && x.details.v8 != x.details.v1).length == 0;
          value = this.total;
        } else {
          isSerialNumbersAdded = true;
        }
        if (isSerialNumbersAdded) {
          if (actionType == ActionType.AmountPaid && this.interactionType != InteractionType.Business && (this.billedItems.bill.v7 == '' || parseInt(this.billedItems.bill.v7) != PaymentType.WalletWithCompany) && this.initialization.paymentMethods.length > 0) {
            this.billedItems.bill.v7 = PaymentType.WalletWithCompany.toString();
            this.billingManagementService.onAction(this.billingId, ActionType.UpdatePaymentMethod, this.billedItems.bill.v7, isShowSpinner).subscribe(result => {
            });
          }
          if (!value)
            value = '';
          if (actionType == ActionType.AmountPaid && this.billedItems.bill.v7 && parseInt(this.billedItems.bill.v7) == PaymentType.WalletWithCompany) {
            this.onShowPayFromWallet();
          } else {
            this.billingManagementService.onAction(this.billingId, actionType, value, isShowSpinner).subscribe(result => {
              this.billingDetailsSimple = result;
              switch (this.billingDetailsSimple.responseStatus.status) {
                case Status.NotAllowed: {
                  this.billedItems.isActionsAllowed = false;
                } break;
                case Status.NeedPrimarySelection: {
                  this.localService.showInformationByStatus(this.billingDetailsSimple.responseStatus.status);
                } break;
                case Status.Success: {
                  switch (actionType) {
                    case ActionType.UndoBilling: {
                      this.onLoad();
                    } break;
                    case ActionType.AmountPaid: {
                      this.onAfterAmountPaid();
                    } break;
                    case ActionType.UpdateAdjustment: {
                      this.billedItems.bill.v18 = value ?? '0';
                    } break;
                    case ActionType.UpdateDiscountAmount: {
                      this.billedItems.bill.v20 = value ?? '0';
                    } break;
                    case ActionType.UpdateAppointment: {
                      this.billedItems.bill.v14 = this.billingDetailsSimple.bill.v14;
                      this.billedItems.bill.v15 = this.billingDetailsSimple.bill.v15;
                    } break;
                    case ActionType.UpdateBillingNotes: {
                      this.isShowNotes = false;
                    } break;
                    case ActionType.UpdateDeliveryAddress: {
                      this.billedItems.bill.v10 = value == '' ? '0' : value;
                      this.onSetDeliveryAddress();
                    } break;
                    case ActionType.UpdatePaymentMethod: {
                      if (value == PaymentType.WalletWithCompany) {
                        this.onShowPayFromWallet();
                      }
                    } break;
                  }
                } break;
                case Status.MinimumRequired: {
                  this.onMinimumQuantityNeed();
                } break;
                case Status.SerialNumberRequired:
                case Status.InventoryRequired: {
                  this.onShowProductValidation(result.responseStatus.status, result.invalidProducts);
                } break;
              }
            });
          }
        } else {
          this.localService.showMessage(this.localService.languageContent.billing.serial_num_required);
        }
      }
    }
    return true;
  }

  selectedQty: number = null; currentPrice: number = null;
  onEditPrice(billingDetailId: string) {
    const item = this.billedItems.products.find(x => x.details.key == billingDetailId);
    if (item) {
      this.selectedQty = parseFloat(item.details.v1?.toString() ?? '0');
      this.currentPrice = parseFloat(item.details.v25?.toString() ?? '0');
      this.selectedBillingDetailId = billingDetailId;
      this.isOpenOwerwritePrice = true;
    }
  }

  onUpdatePrice(data: KeyValues3) {
    this.isOpenOwerwritePrice = false;
    this.billedItems.products.find(x => x.details.key == data.key).details.v4 = data.v1;
    this.billedItems.products.find(x => x.details.key == data.key).details.v17 = '1';
    this.onSetAfterBilledProductsLoad();
    this.onTotal();
  }

  selectedTaxDetails: KeyValueId[];
  onEditDiscount(billingDetailId: string) {
    const item = this.billedItems.products.find(x => x.details.key == billingDetailId);
    if (item) {
      this.selectedTaxDetails = item.taxes;
      this.currentPrice = parseFloat(item.details.v25?.toString() ?? '0');
      if (this.currentPrice == 0) {
        this.currentPrice = parseFloat(item.details.v4?.toString() ?? '0');
      }
      this.selectedBillingDetailId = billingDetailId;
      this.onGetBillingValidation();
      this.isOpenOwerwriteDiscount = true;
    }
  }

  onUpdateDiscount(taxDetails: KeyValueId[]) {
    this.isOpenOwerwriteDiscount = false;
    let item = this.billedItems.products.find(x => x.details.key == this.selectedBillingDetailId);
    if (item) {
      item.taxes = taxDetails;
      this.onTotal();
    }
  }

  onAfterAmountPaid(isPrint: boolean = false, isSendToPhone: boolean = false) {
    if (isPrint || isSendToPhone) {
      this.billedItems.status = BillingStatus.AmountPaid;
      this.billedItems.bill.v4 = '1';
      if (isPrint) {
        this.onPrint();
      } else if (isSendToPhone) {
        this.returnData = { isNavlgateToNewBill: true };
        this.isHiddenProcess = true;
        this.isOpenSendToPhone = true;
      }
    } else if (this.isNaviateToNewBillIfPaid) {
      this.onRoute(1);
    } else {
      this.onLoad();
    }
  }

  onActionByIndex(index: number, key?: string) {
    switch (index) {
      case 1: {
        this.isBillTaxesPopupOpen = true;
      } break;
    }
  }

  onShowPayFromWallet() {
    if (this.billedItems.isActionsAllowed) {
      const modalRef = this.modalService.open(PayFromWalletComponent);
      modalRef.componentInstance.receiptId = this.billingId;
      modalRef.result.then((result) => {
        this.onLoad();
      }, (error) => {
        this.onLoad();
      });
    }
  }

  onSetDeliveryAddress() {
    if (this.billedItems.bill.v13 != '') {
      this.sellerManagementService.getBusinessName(this.businessId, true).subscribe(result => {
        this.billedItems.bill.v16 = result.key;
        this.billedItems.bill.v17 = result.value;
      });
    } else if (this.billedItems.bill.v10 != '0') {
      this.profileManagementService.getDeliveryAddress(this.billedItems.bill.v10).subscribe(result => {
        this.billedItems.bill.v17 = result.value;
      });
    } else {
      this.billedItems.bill.v17 = '';
    }
  }

  onShowProductValidation(status: Status, invalidProducts: KeyValueSet[]) {
    if (this.billedItems.isActionsAllowed) {
      if (status == Status.SerialNumberRequired || status == Status.InventoryRequired) {
        const modalRef = this.modalService.open(ProductValidationComponent, { size: 'sm' });
        modalRef.componentInstance.status = status;
        modalRef.componentInstance.invalidProducts = invalidProducts;
        modalRef.componentInstance.products = this.billedItems.products;
      }
    }
  }

  onPrint() {
    this.isPrint = false;
    setTimeout(() => {
      this.localService.onFocusNextInput(this.elementIds.txt_token_num, FocusInputType.TextBox);
      this.isPrint = true;
    }, 100);
  }

  onSendToPhone(isShowPopup: boolean) {
    this.returnData = null;
    this.isHiddenProcess = !isShowPopup;
    this.isOpenSendToPhone = true;
  }

  isUserAssigned() {
    return this.billedItems && this.billedItems.bill && this.billedItems.bill.v5 && this.billedItems.bill.v5.length > 5;
  }

  onPrinted() {
    this.isPrint = false;
    if (this.interactionType != InteractionType.User && this.isAmountPaid()) {
      if (this.isNaviateToNewBillIfPaid) {
        this.onRoute(1);
      }
    }
  }

  onUpdateFromDropdown(index) {
    switch (index) {
      case 1: {
        this.onReset();
        this.ensureAllProducts(true);
        if (this.billingId != '0') {
          this.billingManagementService.updateBusinessType(this.billingId, this.billedItems.bill.v3, this.businessId).subscribe(result => {
            this.onLoad();
          });
        }
      } break;
    }

  }

  onGetDeletedItems() {
    if (this.billedItems.isActionsAllowed) {
      this.billingManagementService.getDeletedItems(this.billingId).subscribe(result => {
        if (result.length == 0) {
          this.localService.showMessage(this.localService.languageContent.billing.no_deleted_items);
        } else {
          const modalRef = this.modalService.open(DeletedItemsComponent, { ariaLabelledBy: 'modal-basic-title' });
          modalRef.componentInstance.items = result;
        }
      });
    }
  }

  isInvalidRelationFoundCustomer = false;
  isInvalidRelationFoundForBusiness = false;
  isInvalidRelationFoundBusiness = false;
  onUserUpdated(strUserId, index) {
    if (this.billingId == '0') {
      this.billingManagementService.getNewDummyBillingId(this.businessId).subscribe(result => {
        if (result.status == Status.Success) {
          this.billingId = result.id;
          this.onUserUpdatedProcess(strUserId, index, true);
        }
      });
    }
    else {
      this.onUserUpdatedProcess(strUserId, index);
    }
  }

  onUserUpdatedProcess(strUserId, index, isNavigateToNewBilling?: boolean) {
    if (this.billingId != '0') {
      this.billingManagementService.updateBusinessBRN(strUserId, this.billingId, this.businessId, index == 1 || index == 3, index == 3).subscribe(result => {
        if (result.status == Status.Success) {
          switch (index) {
            case 1: {
              this.billedItems.bill.v5 = strUserId;
              this.onSetDeliveryAddress();
            } break;
            case 2: {
              this.billedItems.bill.v6 = strUserId;
            } break;
            case 3: {
              this.billedItems.bill.v13 = strUserId;
              this.onSetDeliveryAddress();
            } break;
          }
        } else if (result.status == Status.UnAvailable) {
          switch (index) {
            case 1: {
              this.isInvalidRelationFoundCustomer = true;
            } break;
            case 2: {
              this.isInvalidRelationFoundBusiness = true;
            } break;
            case 3: {
              this.isInvalidRelationFoundForBusiness = true;
            } break;
          }
        }
        if (isNavigateToNewBilling) {
          this.router.navigate(['/billing' + this.localService.basicParamsString, this.businessId, this.billingId]);
        }
      });
    } else {
      switch (index) {
        case 1: {
          this.billedItems.bill.v5 = strUserId;
        } break;
        case 2: {
          this.billedItems.bill.v6 = strUserId;
        } break;
        case 3: {
          this.billedItems.bill.v13 = strUserId;
        } break;
      }
    }
  }

  onUpdateQty(productId: string, qty: any, batchId: string, measurmentTypeStr: string, isEnter: boolean = false) {
    if (this.valueBeforeFocusOut != qty) {
      if (isEnter) {
        switch (this.billingMode) {
          case BillingMode.Receipt: {
            this.localService.onFocusNextInput(this.elementIds.product_dd, FocusInputType.NgxDropDown);
          } break;
        }
      } else {
        this.billingManagementService.updateQty(this.businessId, this.billingId, productId, qty, this.onGetBillingValidation(), batchId, measurmentTypeStr ? parseInt(measurmentTypeStr) : undefined, this.billedItems.businessTaxes).subscribe(result => {
          switch (result.status) {
            case Status.InventoryRequired: {
              this.onResetQuantity(productId, batchId);
            } break;
            case Status.Success: {
              this.onAfterQtyUpdate(productId, qty, batchId);
            } break;
          }
        });
      }
    }
  }

  onAfterQtyUpdate(productId: string, qty: any, batchId: string) {
    const updatedQty = qty ?? null;
    var billedItem = this.billedItems.products.find(x => x.productId == productId && x.details.v15 == batchId);
    if (billedItem) {
      billedItem.details.v1 = updatedQty;
      billedItem.details.v18 = updatedQty;

      if (this.searchItems && this.searchItems.length > 0) {
        var searchItem = this.searchItems.find(x => x.key == productId && x.v15 == batchId);
        if (searchItem) {
          searchItem.v1 = updatedQty;;
        }
      }
    }
    this.onTotal();
  }

  onArrowClick(index) {
    switch (index) {
      case 1: {
        this.isSearchbarShow = !this.isSearchbarShow;
      } break;
      case 2: {
        this.isFooterbarShow = !this.isFooterbarShow;
      } break;
    }
  }

  onShowHideDropDown(index, isHide: boolean = false) {
    this.onShowHideButton(3);
    if (isHide)
      this.isDropDownInFooter = 0;
    else
      this.isDropDownInFooter = this.isDropDownInFooter == 0 ? index : 0;
    if (this.isDropDownInFooter > 0) {
      switch (index) {
        case 1: {
          this.localService.onFocusFooterDropDown(this.elementIds.payment_mode, this.elementIds.dd_payment_mode);
        } break;
        case 2: {
          this.localService.onFocusFooterDropDown(this.elementIds.print_language, this.elementIds.dd_print_language);
        } break;
        case 3: {
          this.localService.onFocusFooterDropDown(this.elementIds.delivery_method, this.elementIds.dd_delivery_method);
        } break;
      }
    }
  }

  isShowNotes = false; isShowSummary = false;
  onShowHideButton(index) {
    if (index != 2 && index != 3)
      this.onShowHideButton(3);
    switch (index) {
      case 1: {
        this.isShowNotes = !this.isShowNotes;
        this.localService.onFocusNextInput(this.elementIds.txt_notes, FocusInputType.TextBox);
      } break;
      case 2: {
        this.isShowSummary = !this.isShowSummary;
        this.localService.onFocusNextInput(this.elementIds.txt_notes_summary, FocusInputType.TextBox);
      } break;
      case 3: {
        this.isShowSummary = false;
      } break;
    }
  }

  onGenerateBarCode() {
    if (this.billedItems.isActionsAllowed) {
      //modalRef.componentInstance.value = this.billingId;
      //modalRef.componentInstance.categoryCode = BarCodeCategory.Billing;
      //modalRef.componentInstance.countryCode = this.ctryCode;
    }
  }

  onShowHistory() {
    const modalRef = this.modalService.open(BillHistoryComponent, { size: 'lg' });
    modalRef.componentInstance.billingId = this.billingId;
  }

  onOpenDeliveryAddress(editId = '') {
    if (this.billedItems.isActionsAllowed) {
      if (this.billedItems.bill.v8 == DeliveryType.Door.toString() && this.billedItems.bill.v13 == '' && (this.billedItems.bill.v10 == '0' || editId != '')) {
        if (this.billedItems.bill.v5) {
          const modalRef = this.modalService.open(EditAdditionalDetailsComponent);
          modalRef.componentInstance.id = this.billedItems.bill.v5;
          modalRef.componentInstance.isPickMode = true;
          modalRef.componentInstance.editId = editId;
          modalRef.componentInstance.ctryCode = this.ctryCode;
          modalRef.result.then((result) => {
            if (result.event == TriggeredEvent.Ok) {
              this.onAction(ActionType.UpdateDeliveryAddress, result.data);
            }
          });
        } else {
          this.localService.showMessage(this.localService.languageContent.billing.customer_required);
        }
      }
    }
  }

  onToggleQuickPick(strKey, qty) {
    if (this.isAddOrDeleteProduct) {
      let item = this.billedItems.products.find(x => x.productId == strKey);
      if (item) {
        this.onRemoveProduct(strKey);
      } else {
        if (!qty || qty == 0)
          qty = 1;
        let item = this.searchItems.find(x => x.key == strKey);
        item.v1 = qty;
        this.onSaveBilling(strKey, qty);
      }
    }
  }

  onAdjustQuickQty(index, productId, strQty, batchId: string, measurmentTypeStr: string, currentIndex = 0, isEnter = false) {
    let qty: number = strQty && strQty != '' ? parseFloat(strQty) : 0;
    switch (index) {
      case 1: {
        qty = qty - 1;
      } break;
      case 2: {
        if (!qty || qty == 0)
          qty = 1;
        else
          qty = qty + 1;
      } break;
    }
    let item = this.searchItems.find(x => x.key == productId);
    item.v1 = qty == 0 ? null : qty;
    if (!batchId) {
      batchId = '';
    }
    if (this.billedItems && this.billedItems.products && this.billedItems.products.find(x => x.productId == productId && x.details.v15 == batchId)) {
      if (qty <= 0) {
        this.onRemoveProduct(productId, batchId, measurmentTypeStr);
      } else if (qty > 0) {
        let product = this.billedItems.products.find(x => x.productId == productId && x.details.v15 == batchId) as BilledProduct;
        if (product.details.v1 != qty) {
          this.onUpdateQty(productId, qty, batchId, measurmentTypeStr, isEnter);
        }
      }
    } else if (qty > 0) {
      this.onSaveBilling(productId, qty);
    }

    if (isEnter) {
      switch (this.billingMode) {
        case BillingMode.Receipt: {
          this.localService.onFocusNextInput(this.elementIds.product_dd, FocusInputType.NgxDropDown);
        } break;
        case BillingMode.ShowAll: {
          if (this.searchItems.length > currentIndex + 1) {
            let nextNavigateId = 'prd_' + this.searchItems[currentIndex + 1].key;
            this.localService.onFocusNextInput(nextNavigateId, FocusInputType.TextBox);
          } else {
            this.localService.onFocusNextInput(this.interactionType == InteractionType.User ? this.elementIds.btn_submit : this.elementIds.btn_accept, FocusInputType.Button);
          }
        } break;
      }
    }
  }

  onGetName(index, id = '') {
    let item: KeyValueSet;
    switch (index) {
      case 1: {
        item = this.localService.paymentTypes.find(x => x.key == this.billedItems.bill.v7);
      } break;
      case 2: {
        item = this.localService.deliveryTypes.find(x => x.key == this.billedItems.bill.v8);
      } break;
      case 3: {
        item = this.initialization.measurementTypes.find(x => x.key == id);
      } break;
    }
    return item ? item.value : this.localService.languageContent.billing.not_found;
  }

  onOpenSeatArrangements() {
    const modalRef = this.modalService.open(SeatsBillingComponent);
    modalRef.componentInstance.billingId = this.billingId;
    modalRef.componentInstance.businessId = this.businessId;
    modalRef.componentInstance.tokenNumber = this.billedItems.bill.v2;
    modalRef.componentInstance.isAllowToEdit = this.interactionType == InteractionType.Business;
  }

  isSeatingElligible(): boolean {
    return this.billedItems && this.billedItems.bill.v2 && this.billedItems.bill.v2 != '' && this.initialization.deliveryTypes.filter(x => x.key == DeliveryType.Dining.toString()).length > 0;
  }

  isAmountPaid(): boolean {
    return this.billedItems && this.billedItems.bill.v4 && this.billedItems.bill.v4 != '0';
  }

  isBusinessOptionVisible(businessEnabledOption: BusinessEnabledOption): boolean {
    return this.initialization && this.initialization.businessEnabledOptions && this.initialization.businessEnabledOptions.includes(businessEnabledOption);
  }

  onClosesBillTaxesPopup(event: any) {

  }

  isReturned(productId: string, batchId: string): boolean {
    const item = this.billedItems.products.find(x => x.productId == productId && x.details.v15 == batchId);
    return this.isAmountPaid() && item && item.details && item.details.v7 && item.details.v7 != '' && item.details.v7 != '0';
  }

  isReturnAvailable(): boolean {
    return this.isAmountPaid() && this.billedItems.products.filter(item => item.details.v7 && item.details.v7 != '' && item.details.v7 != '0').length > 0;
  }

  onConvertDiscountFromPercentage(event?: any) {
    if (event) {
      const charCode = (event.which) ? event.which : event.keycode;
      if (charCode == 37 && event.target.value && event.target.value.toString().length > 0) {
        const totalAmount = parseFloat(this.onGetPriceIncludeTax().toFixed(2));
        const percentage = parseFloat(parseFloat(event.target.value.toString()).toFixed(2));
        if (totalAmount > 0 && percentage > 0) {
          this.txtDiscount = parseFloat(((percentage / 100) * totalAmount).toFixed(2));
          this.onTotal();
        }
      }
    }
  }

  onSelectedPaymentMode(key: number) {
    this.billedItems.bill.v7 = key.toString();
  }

  onSent(res: any) {
    if (res) {
      if (res.isNavlgateToNewBill) {
        this.onRoute(1);
      }
    }
  }

  onPaid(res: any) {
    const status: Status = res.status;
    const isPrint: boolean = res.isPrint;
    const isSendToPhone: boolean = res.isSendToPhone;

    if (status != Status.Success) {
      this.onLoad();
    }
    switch (status) {
      case Status.QrPaymentGenerated: {
        this.isGenerateQr = true;
      } break;
      case Status.Success: {
        this.onAfterAmountPaid(isPrint, isSendToPhone);
      } break;
      case Status.NeedBRN: {
        this.localService.showMessage(this.localService.languageContent.billing.need_customer_brn);
      } break;
      case Status.MinimumRequired: {
        this.localService.showInformationByStatus(Status.MinimumRequired, true);
        this.onMinimumQuantityNeed();
      } break;
      case Status.SerialNumberRequired:
      case Status.InventoryRequired: {
        this.onShowProductValidation(status, []);
      } break;
    }
  }
}
